import { MeetingProvider } from "@videosdk.live/react-sdk";
import { useEffect } from "react";
import { useState } from "react";
import { MeetingAppProvider } from "./MeetingAppContextDef";
import { MeetingContainer } from "./meeting/MeetingContainer";
import { LeaveScreen } from "./components/screens/LeaveScreen";
import { JoiningScreen } from "./components/screens/JoiningScreen"
import { getToken, info_cita } from "./api";
//import { getParticipants } from "./api-participants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  const [token, setToken] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [micOn, setMicOn] = useState(false);
  const [webcamOn, setWebcamOn] = useState(false);
  const [customAudioStream, setCustomAudioStream] = useState(null);
  const [customVideoStream, setCustomVideoStream] = useState(null)
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [isMeetingLeft, setIsMeetingLeft] = useState(false);
  const [cita, setCita] = useState(null);
  const [alerta, setAlerta] = useState('');
  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;
  const traducir = (enmascarado) => {
    try {
      let dataDecodificada = atob(enmascarado);
      let parametros = dataDecodificada.split('|');
      return {
        empresa: parametros[0],
        sala: parametros[1],
        usuario: parametros[2],
        id_profesional: parametros[3],
      };
    } catch (e) {
      return {};
    }
  }
  const infodc = async (rim, emps) => {
    const T = await info_cita({
      roomId: rim,
      emp: emps
    });
    setCita(T);
    return T;
  }
  const cita_valida = (data) => {

    //localStorage.colores=data.empresa.colores;
    if (!data || !data.cita) {
      setAlerta("No se encontró información de la cita.".toLocaleUpperCase());
      toast.error("No se encontró información de la cita.");

      return false;
    }// Estados válidos: 1 (Reservada), 3 (Confirmada)
    const estadosValidos = [1, 3];
    if (!estadosValidos.includes(data.cita.estado)) {
      setAlerta("La cita no está disponible o ya fue atendida/cancelada.".toLocaleUpperCase());
      toast.error("La cita no está disponible o ya fue atendida/cancelada.");

      return false;
    }
    const hoy = new Date();
    const fechaCita = new Date(data.cita.start);
    if (
      hoy.getFullYear() !== fechaCita.getFullYear() ||
      hoy.getMonth() !== fechaCita.getMonth() ||
      hoy.getDate() !== fechaCita.getDate()
    ) {
      setAlerta(`La cita no corresponde al día de hoy. ${data.cita.start}`.toLocaleUpperCase());
      toast.error("La cita no corresponde al día de hoy.");
      return false;
    }
    // Puedes agregar más validaciones aquí si lo necesitas
    return true;
  }
  const inicialr = async () => {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    let verificado = traducir(pathParts[1]);
    console.log(verificado);
    if (pathParts.length > 1) {
      if (verificado != {}) {
        let value = await infodc(verificado.sala, verificado.empresa);
        if (cita_valida(value)) {
          if (value.cita.profesionales_jm.split(',').includes(verificado.id_profesional)) {
            // Suponiendo que el id de la sala es el último segmento de la ruta y tiene longitud típica de un id
            const usuario = verificado.usuario;//pathParts.length > 0 ? pathParts[pathParts.length - 2] : null;
            const salaId = verificado.sala;//pathParts.length > 0 ? pathParts[pathParts.length - 1] : null;
            if (salaId && salaId.length >= 6 && !isMeetingStarted) {
              setMeetingId(salaId);
              setParticipantName(usuario);
              // Obtener token y conectar automáticamente
              getToken().then(async (tk) => {
                setToken(tk);
                // Validar que el usuario no esté repetido
                const participantes = [];// await getParticipants({ roomId: salaId, token: tk });
                console.log(usuario, participantes);
                const existe = participantes.includes(usuario)
                if (existe) {
                  toast.warning("El usuario ya está conectado en la sala. Por favor, usa otro nombre o espera a que se desconecte.");
                } else {
                  setMeetingStarted(true);
                }
              });
            }
          } else {
            setAlerta("usuario no es invitado a la consulta".toLocaleUpperCase());
            toast.error("Link inválido");
          }
        } 
      } else {
        setAlerta("Link inválido".toLocaleUpperCase());
        toast.error("Link inválido");
      }
    } else {
      setAlerta("Link inválido".toLocaleUpperCase());
      toast.error("Link inválido");
    }
  }
  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
  }, [isMobile]);

  useEffect(() => {
    inicialr();
  }, []);

  return (
    <>

      <MeetingAppProvider>
        {isMeetingStarted ? (
          <MeetingProvider
            config={{
              meetingId,
              micEnabled: micOn,
              webcamEnabled: webcamOn,
              name: participantName ? participantName : "TestUser",
              multiStream: true,
              customCameraVideoTrack: customVideoStream,
              customMicrophoneAudioTrack: customAudioStream
            }}
            token={token}
            reinitialiseMeetingOnConfigChange={true}
            joinWithoutUserInteraction={true}
          >

            ( <MeetingContainer
              onMeetingLeave={() => {
                setToken("");
                setMeetingId("");
                setParticipantName("");
                setWebcamOn(false);
                setMicOn(false);
                setMeetingStarted(false);
              }}
              setIsMeetingLeft={setIsMeetingLeft}
            />)
          </MeetingProvider>

        ) : isMeetingLeft ? (
          <LeaveScreen setIsMeetingLeft={setIsMeetingLeft} />
        ) : (

          <JoiningScreen
            participantName={participantName}
            setParticipantName={setParticipantName}
            setMeetingId={setMeetingId}
            setToken={setToken}
            micOn={micOn}
            setMicOn={setMicOn}
            webcamOn={webcamOn}
            setWebcamOn={setWebcamOn}
            customAudioStream={customAudioStream}
            setCustomAudioStream={setCustomAudioStream}
            customVideoStream={customVideoStream}
            setCustomVideoStream={setCustomVideoStream}
            onClickStartMeeting={() => {
              setMeetingStarted(true);
            }}
            startMeeting={isMeetingStarted}
            setIsMeetingLeft={setIsMeetingLeft}
            alerta={alerta}
          />
        )}
      </MeetingAppProvider>

    </>
  );
}

export default App;
